import { ElementType } from 'react'
import styled from 'styled-components'
import { Button as ButtonMui } from '@mui/material'

export const Button = styled(ButtonMui)<{ component: ElementType, $bgColor?: string, $hoverColor?: string, $letterColor?: string }>`
  color: ${({ $letterColor }) => $letterColor} !important;
  background-color: ${({ $bgColor }) => $bgColor} !important;

  &:hover {
    background-color: ${({ $hoverColor }) => $hoverColor} !important;
  }
`

export const Input = styled.input``
